import { useTranslation } from 'react-i18next'
import { SummarySection } from './SummarySection'
import { PremiumBeneMessages, PremiumSummaryInfo } from '@cms-max/medicare-api-sdk'
import { MyInternalLink } from 'components/MyLink'
import Skeleton from 'react-loading-skeleton'
import { useEvent } from 'hooks/useEvent'

type MyBillsProps = {
    isLoading?: boolean
    summaryData?: PremiumSummaryInfo
}
export function MyBills ({ isLoading, summaryData }: MyBillsProps) {
  const { t, i18n } = useTranslation('premiumsDashboardPage')
  const lang = i18n.language as 'en' | 'es'
  const { fireEvent } = useEvent('premiumsLanding')
  const beneMessages = summaryData?.beneMessages
  const hasPaymentDue = Boolean(beneMessages?.paymentDue)
  const value = isLoading ? <Skeleton height={112} /> : hasPaymentDue ? <PaymentDue paymentDue={beneMessages?.paymentDue} /> : null

  return (
    <SummarySection
        heading={isLoading ? <Skeleton width={159} /> : t('myBills.heading')}
        value={value}
        valueColor={isLoading ? undefined : 'green'}
        isLoading={isLoading}
    >
        {isLoading && <Skeleton height={101} />}
        {!isLoading && (
          <>
            {beneMessages?.lastBill && <p>{beneMessages?.lastBill[lang]}</p>}

            {beneMessages?.paymentProcessed && <p>{beneMessages?.paymentProcessed[lang]}</p>}
            {beneMessages?.noPremiumOwed && <p>{beneMessages?.noPremiumOwed[lang]}</p>}
            {summaryData?.isDirectBillingEligible && <p><MyInternalLink to="/premiums/bills" onClick={(params) => fireEvent('premiums_landingpage_currentandpastbills_click', params)}>{t('myBills.billHistoryLink')}</MyInternalLink></p>}
          </>
        )}
    </SummarySection>
  )
}

export default MyBills

type PaymentDueProps = Pick<PremiumBeneMessages, 'paymentDue'>
function PaymentDue ({ paymentDue }: PaymentDueProps) {
  const { i18n } = useTranslation('premiumsDashboardPage')
  const lang = i18n.language as 'en' | 'es'
  const paymentDueStr = paymentDue?.[lang]

  const matches = paymentDueStr?.match(/([^\d]*)(\d+\/\d+\/\d+).?/)

  return (
    <div>
      {matches && matches.length > 1
        ? (
        <>
          <div className='ds-text-body--md'>{matches[1]}:</div>
          <div className="ds-text-body--lg ds-u-font-weight--semibold">{matches[2]}</div>
        </>
          )
        : paymentDueStr ? (<div className='ds-text-body--md'>{paymentDueStr}</div>) : null}
    </div>
  )
}
